var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "日志详情",
            top: "100px",
            width: "800px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: { model: _vm.details, "label-width": "90px" },
            },
            [
              _c("el-form-item", { attrs: { label: "日志描述：" } }, [
                _vm._v(_vm._s(_vm.details.logInfo || "--")),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "日志时间：" } }, [
                _vm._v(_vm._s(_vm.details.updatedAt || "--")),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "请求参数：" } }, [
                _vm._v(_vm._s(_vm.details.requestParams || "--")),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "响应参数：" } }, [
                _vm._v(_vm._s(_vm.details.responseParams || "--")),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }